import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Showcase from '@/views/client/Showcase/Showcase.vue'
import LandingPage from '@/views/landingPage/LandingPage.vue'
import PageNotFound from '@/views/pageNotFound/PageNotFound.vue'
import LoginAccount from '@/views/admin/access/login/Login.vue'
import DashBoard from '@/views/admin/dashboard/Dashboard.vue'
import RegisterAccount from '@/views/admin/access/register/Register.vue'
import LinksAdmin from '@/views/admin/linksAdmin/LinksAdmin.vue'
import HomeAdmin from '@/views/admin/homeAdmin/HomeAdmin.vue'

Vue.use(VueRouter)

const routes: any = [
  {
    path: '/',
    // component: LandingPage,
    redirect: '/ifc_maravilhas'
  }
  // ,{
  //   name: 'login',
  //   path: '/login',
  //   component: LoginAccount
  // }
  // ,{
  //   name: 'register',
  //   path: '/register',
  //   component: RegisterAccount,
  //   // meta: {​​
  //   //   requiresAuth: true
  //   // }​​
  // }
  // ,{
  //   name: 'admin',
  //   path: '/admin',
  //   component: DashBoard,
  //   // meta: {​​
  //   //   requiresAuth: true
  //   // }​​
  // },
  // {
  // name: 'links',
  // path: '/admin/links',
  // component: LinksAdmin
  // }
  // ,{
  //   name: 'homeadmin',
  //   path: '/home',
  //   component: HomeAdmin,
  //   // meta: {​​
  //   //   requiresAuth: true
  //   // }​​
  // }
  ,{
    path: '/:slug',
    component: Showcase
  }
]
  
const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {​​
  const loggedUser = localStorage.getItem('user');

  console.log('>>',to)

  if (to.matched.some(record => record.meta.requiresAuth)) {​​
    if (loggedUser != null) {​​
      if( to.name == 'login' || to.name == 'register' ){
        return next({path: '/admin'})
      }else{
        return  next();
      }
    }​​ else {​​
      return next({​​
        path: '/'
      }​​);
    }​​
  }​​ else {​​
    return next();
  }​​
}​​)

export default router
